<template>
  <div class="menu-page">
    <div class="toolbar">
      <el-button type="primary" @click="openDialog">新增菜单</el-button>
    </div>
<el-table :data="list" style="width:100%" stripe>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column label="父节点" width="80">
        <template #default="{row}">
          <el-input-number v-model="row.parent_id" :min="0" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="菜单名称">
        <template #default="{row}">
          <el-input v-model="row.title" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="icon图标">
        <template #default="{row}">
          <el-input v-model="row.icon" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="path">
        <template #default="{row}">
          <el-input v-model="row.path" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="permission">
        <template #default="{row}">
          <el-input v-model="row.permission" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="排序" width="80">
        <template #default="{row}">
          <el-input-number v-model="row.sort" :min="0" size="small" />
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80">
        <template #default="{row}">
          <el-tag :type="row.status ? 'success':'info'">{{row.status? '启用':'禁用'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template #default="{row}">
          <el-button size="small" @click="edit(row)">更新</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" :current-page="pagination.page" :page-size="pagination.pageSize" :total="pagination.total" layout="prev, pager, next" @current-change="pageChange" />

    <el-dialog v-model="dialogVisible" title="菜单信息" width="400px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="父节点">
          <el-input-number v-model="form.parent_id" :min="0" />
        </el-form-item>
        <el-form-item label="菜单名称">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="icon">
          <el-input v-model="form.icon" />
        </el-form-item>
        <el-form-item label="path">
          <el-input v-model="form.path" />
        </el-form-item>
        <el-form-item label="permission">
          <el-input v-model="form.permission" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="禁用" :value="0" />
            <el-option label="启用" :value="1" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import request from '../../utils/request'

const list = ref([])
const pagination = ref({page:1,pageSize:30,total:0})
const dialogVisible = ref(false)
const loading = ref(false)
const form = ref({ id:null, parent_id:0, title:'', icon:'', path:'', permission:'', sort:0, status:1 })

const loadList = async () => {
  const params={page:pagination.value.page,pageSize:pagination.value.pageSize}
  try{
    const data = await request.get('/v1/admin/menu/list',{params})
    list.value = data.list
    pagination.value.total = data.pagination.total
  }catch(e){ ElMessage.error(e.toString()) }
}

const openDialog = () => { form.value={ id:null,parent_id:0,title:'',icon:'',path:'',permission:'',sort:0,status:1}; dialogVisible.value=true }

const edit = async(row)=>{
  loading.value=true
  try{
    await request.post('/v1/admin/menu/update',row)
    ElMessage.success('保存成功')
  }catch(e){ ElMessage.error(e.toString()) }
  finally{ loading.value=false }
}

const submit = async()=>{
  loading.value=true
  try{
    if(form.value.id) await request.post('/v1/admin/menu/update', form.value)
    else await request.post('/v1/admin/menu/create', form.value)
    ElMessage.success('操作成功')
    dialogVisible.value=false
    loadList()
  }catch(e){ ElMessage.error(e.toString()) }
  finally{ loading.value=false }
}

const remove = async(row)=>{
  try{ await request.post('/v1/admin/menu/delete',{ id:row.id }); ElMessage.success('删除成功'); loadList() }catch(e){ ElMessage.error(e.toString()) }
}

const pageChange = (p)=>{ pagination.value.page = p; loadList() }

loadList()
</script>

<style scoped>
.menu-page .toolbar{margin-bottom:15px}
.pager{margin-top:15px;text-align:right}
</style>
